import { Component, Input, OnInit } from '@angular/core';
import { ItemPostComment } from "../../../../states/Item/item.actions";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AlertPopupService } from "../../../../shared/services/alert-popup.service";
import { Store } from "@ngrx/store";
import { OrderPostComment } from 'src/app/states/Order/order.actions';

@Component({
	selector: 'app-write-a-review',
	templateUrl: './write-a-review.component.html',
	styleUrls: ['./write-a-review.component.scss']
})
export class WriteAReviewComponent implements OnInit {
	@Input() itemId: string;
	@Input() orderId: string;
	@Input() isPaymentPage: boolean
	public form: FormGroup;
	public showRatingInCentre: boolean;

	constructor(
		private formBuilder: FormBuilder,
		private alertPopupService: AlertPopupService,
		private store: Store,
	) {
	}

	ngOnInit(): void {
		this.form = this.formBuilder.group({
			'rating': [5, [Validators.required]],
			'comments': [null, [Validators.required, Validators.maxLength(100)]],
		});

		this.orderId ? this.showRatingInCentre = true : this.showRatingInCentre = false;
	}

	public onSubmit(form: FormGroup) {
		try {
			if (form.valid) {
				if (this.itemId) {
					this.store.dispatch(
						new ItemPostComment({
							itemId: this.itemId,
							payload: form.value,
						})
					);
				} else if (this.orderId) {
					this.store.dispatch(
						new OrderPostComment({
							orderId: this.orderId,
							payload: form.value,
							isPaymentPage: this.isPaymentPage
						})
					);
				}
			} else {
				form.markAllAsTouched();
				this.alertPopupService.showWarningAlert('You missed to fill some required fields.');
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}

	public markTouchedAndDirty(value: string | boolean, key: string, form: FormGroup): void {
		form.controls[key].markAsTouched();
		if (!value) {
			form.controls[key].markAsDirty();
		}
	}
}
